import mixin from "./yearCalculations.js";
export default {
    name: "collection",
    mixins: [mixin],
    methods: {
        alphabetize: function(data) {
            let array = Object.entries(data).sort((a, b) => {
                if (a[1] < b[1]) {
                    return -1;
                } else if (a[1] > b[1]) {
                    return 1;
                }
                return 0;
            });
            return array;
        },
        loadCountries: function(queries) {
          if (!this.$global.collectionCountries || queries !== "&") {
            return axios({ method: "GET", "url": `${process.env.VUE_APP_DXA_ENDPOINT}/items/countries?hash=${process.env.VUE_APP_API_HASH}${queries}` }).then(result => {
              if (!this.$global.collectionCountries) {
                this.$global.collectionCountries = this.alphabetize(result.data);
              }
              this.countries = this.alphabetize(result.data);
            }, error => {
              console.error(error);
            });
          } else {
            this.countries = this.$global.collectionCountries;
            return Promise.resolve();
          }
        },
        loadTags: function(queries) {
          if ((!this.$global.collectionTypes && !this.$global.collectionMaterials && !this.$global.collectionDynasties && !this.$global.collectionSubjects) || queries !== "&") {
            return axios({ method: "GET", "url": `${process.env.VUE_APP_DXA_ENDPOINT}/items/tags?hash=${process.env.VUE_APP_API_HASH}${queries}` }).then(result => {
              let typeRegex = /type/g;
              let dynastyRegex = /dynasty/g;
              let subjectRegex = /subject/g;
              let materialRegex = /material/g;
              let array = this.alphabetize(result.data);
              for (let i = 0; i < array.length; i++) {
                  array[i][1] = array[i][1].charAt(0).toUpperCase() + array[i][1].slice(1);
              }
              let typeFiltered = array.filter(item => item[0].match(typeRegex));
              let dynastyFiltered = array.filter(item => item[0].match(dynastyRegex));
              let subjectFiltered = array.filter(item => item[0].match(subjectRegex));
              let materialFiltered = array.filter(item => item[0].match(materialRegex));
              if (!this.$global.collectionTypes && !this.$global.collectionMaterials && !this.$global.collectionDynasties && !this.$global.collectionSubjects) {
                this.$global.collectionTypes = typeFiltered;
                this.$global.collectionDynasties = dynastyFiltered;
                this.$global.collectionSubjects = subjectFiltered;
                this.$global.collectionMaterials = materialFiltered;
              }
              this.types = typeFiltered;
              this.dynasties = dynastyFiltered;
              this.subjects = subjectFiltered;
              this.materials = materialFiltered;
            }, error => {
                console.error(error);
            });
          } else {
            this.types = this.$global.collectionTypes;
            this.dynasties = this.$global.collectionDynasties;
            this.subjects = this.$global.collectionSubjects;
            this.materials = this.$global.collectionMaterials;
            return Promise.resolve();
          }
        },
        loadYears: function(queries) {
          if (!this.$global.collectionYears || queries !== "&") {
            return axios({ method: "GET", "url": `${process.env.VUE_APP_DXA_ENDPOINT}/items/years?hash=${process.env.VUE_APP_API_HASH}${queries}` }).then(result => {
              let min, max;
              if (parseInt(result.data.minYear)) {
                min = parseInt(result.data.minYear);
              } else {
                min = -10000;
              }
              if (parseInt(result.data.maxYear)) {
                max = parseInt(result.data.maxYear);
              } else {
                max = new Date().getFullYear();
              }
              // let min = parseInt(result.data.minYear);
              // let max = parseInt(result.data.maxYear);
              let increments = [500, 250, 100, 50];
              let smallestIncrement;
              let array = [min];
              let minRounded, maxRounded;

              if (max >= 1800) {
                maxRounded = this.getPreviousMultiple(max, increments[3]);
              } else if (max >= 1000) {
                maxRounded = this.getPreviousMultiple(max, increments[2]);
              } else if (max >= 0) {
                maxRounded = this.getPreviousMultiple(max, increments[1]);
              } else if (max < 0) {
                maxRounded = this.getPreviousMultiple(max, increments[0]);
              }
              if (min <= 0) {
                minRounded = this.getNextMultiple(min, increments[0]);
              } else if (min <= 1000) {
                minRounded = this.getNextMultiple(min, increments[1]);
              } else if (min <= 1800) {
                minRounded = this.getNextMultiple(min, increments[2]);
              } else if (min > 1800) {
                minRounded = this.getNextMultiple(min, increments[3]);
              }

              do {
                  if (minRounded < 0) {
                    this.pushIncrements(minRounded, maxRounded, 0, increments[0], array);
                    minRounded = array[array.length - 1];
                    smallestIncrement = increments[0];
                  } else if (minRounded < 1000) {
                    this.pushIncrements(minRounded, maxRounded, 1000, increments[1], array);
                    minRounded = array[array.length - 1];
                    smallestIncrement = increments[1];
                  } else if (minRounded < 1800) {
                    this.pushIncrements(minRounded, maxRounded, 1800, increments[2], array);
                    minRounded = array[array.length - 1];
                    smallestIncrement = increments[2];
                  } else if (minRounded >= 1800) {
                    this.pushIncrements(minRounded, maxRounded, maxRounded, increments[3], array);
                    minRounded = array[array.length - 1];
                    smallestIncrement = increments[3];
                  }
                } while (array[array.length - 1] < maxRounded);

                array.push(max);
                array = [...new Set(array)];
                let yearsWithLabels = [];
                // skips 0 currently
                for (let i = 0; i < array.length; i++) {
                  if (array[i] < 0) {
                    yearsWithLabels.push([array[i], Math.abs(array[i]) + " B.C."]);
                  } else if (array[i] > 0) {
                    yearsWithLabels.push([array[i], array[i] + " A.D."]);
                  }
                }

                let before1000BC = false;
                if (yearsWithLabels[0][0] < -1000) {
                    before1000BC = true;
                }
                let displayYears = [];
                if (before1000BC) {
                    for (let j = 0; j < yearsWithLabels.length; j++) {
                        if (yearsWithLabels[j][0] < -1000) {
                            continue;
                        } else {
                            displayYears.push(yearsWithLabels[j]);
                        }
                    }
                    displayYears.unshift([min, "Before 1000 B.C."]);
                } else {
                    displayYears = yearsWithLabels;
                }

                let y = displayYears;
                // Check length to avoid error from undefined
                if (y.length > 0) {
                    if (y[y.length - 1][0] - y[y.length - 2][0] < smallestIncrement) {
                        displayYears[displayYears.length - 1][1] = `After ${displayYears[displayYears.length - 2][1]}`;
                    }
                }
                if (!this.$global.collectionYears) {
                  this.$global.collectionYears = displayYears;
                }
                this.years = displayYears;

                // If start/end doesn't match the first/last in years
                // Selections have defaulted to something outside of provided increments
                // The fewer objects returned, the more likely this is to happen
                // Set start/end to the "new" specific dates
                // 1950 A.D. vs. 1951 A.D.
                if (this.start !== "" && this.start !== this.years[0][0]) {
                    this.start = this.years[0][0];
                }
                if (this.end !== "" && this.end !== this.years[this.years.length - 1][0]) {
                    this.end = this.years[this.years.length - 1][0];
                }
            }, error => {
                console.error(error);
            });
          } else {
            this.years = this.$global.collectionYears;
            return Promise.resolve();
          }
        },
    }
}